"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MoneyBagFilled = function MoneyBagFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.053 3.724a.5.5 0 01.093-.578A4.875 4.875 0 0110.5 2a5.055 5.055 0 012.252.653 4.147 4.147 0 003.59.372.5.5 0 01.605.7L15.309 7H8.691zM20 16a8 8 0 01-1.863 5.121 2.482 2.482 0 01-1.911.879H7.774a2.482 2.482 0 01-1.911-.879A8 8 0 014 16c0-3.451 2.691-6.54 4.2-8h7.6c1.509 1.46 4.2 4.549 4.2 8zm-5.5.063c0-1.434-1.185-1.958-2.137-2.378C11.435 13.274 11 13.023 11 12.5a1 1 0 01.652-.905 1.356 1.356 0 011.5.37.5.5 0 00.7-.711 2.533 2.533 0 00-1.352-.7V9.5a.5.5 0 00-1 0v1.114a1.9 1.9 0 00-.234.057A2 2 0 0010 12.5c0 1.232 1.087 1.714 1.961 2.1.956.422 1.541.719 1.541 1.464a1.286 1.286 0 01-.8 1.3 2.277 2.277 0 01-2.349-.518.5.5 0 00-.7.711 3.339 3.339 0 001.852.9V19.5a.5.5 0 001 0v-1.048a2.71 2.71 0 00.586-.165 2.284 2.284 0 001.409-2.224z",
    fill: "currentColor"
  })));
};

var _default = MoneyBagFilled;
exports["default"] = _default;